module.exports = {"markup":"<span class=\"inline-adblock-coins-us inline-commercial\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"570\" height=\"134\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 570 134\"><g fill=\"#fff\"><path d=\"M152.2 87h4V47h-4z\"/><path d=\"M134 65v4h40v-4z\"/></g><g fill=\"#fff\"><path d=\"M348.2 87h4V47h-4z\"/><path d=\"M330 65v4h40v-4z\"/></g><g fill=\"#fff\"><path d=\"M529.2 56.2v4H569v-4zM529 76v4h39.8v-4z\"/></g><image width=\"512\" height=\"134\" preserveAspectRatio=\"none\" xlink:href=\"%%URL%%\"/></svg></span>"}


//////////////////
// WEBPACK FOOTER
// ./static/src/inline-svgs/commercial/adblock-coins-us.svg
// module id = 337
// module chunks = 5 15